/**
 * DESIGN.md tokens used by the pricing UI. Kept as constants (the PlanCard
 * pattern: inline hex for the few values Tailwind's palette does not carry).
 */
export const T = {
  canvas: '#0a0a0a',
  surface: '#121212',
  surface2: '#1a1a1a',
  borderSubtle: 'rgba(255,255,255,0.06)',
  borderRegular: 'rgba(255,255,255,0.10)',
  t1: '#f5f5f5',
  t2: '#a3a3a3',
  // 4.97:1 on surface2 / 5.4:1 on surface (WCAG AA for the 13-14px hints it
  // carries); #737373 was 3.7:1 (design review 2026-10-08, FINDING-008).
  t3: '#8a8a8a',
  blue: '#3264F8',
  warn: '#fbbf24',
  success: '#34d399',
  danger: '#ef4444',
} as const;

// 44px targets everywhere (a11y pass 6; 36px has slipped through before).
const base =
  'inline-flex items-center justify-center rounded-lg px-4 text-sm font-medium transition-colors motion-reduce:transition-none ' +
  'focus:outline-none focus-visible:ring-2 focus-visible:ring-[#3264F8] focus-visible:ring-offset-2 focus-visible:ring-offset-[#121212] ' +
  'disabled:opacity-50 disabled:cursor-not-allowed';

export const BTN_PRIMARY = `${base} min-h-[44px] bg-[#3264F8] text-white hover:bg-[#2554e0]`;
export const BTN_QUIET = `${base} min-h-[44px] border border-white/10 bg-transparent text-[#f5f5f5] hover:bg-white/[0.04]`;
export const BTN_LINK =
  'inline-flex items-center min-h-[44px] px-1 text-sm underline underline-offset-2 text-[#a3a3a3] hover:text-[#f5f5f5] ' +
  'focus:outline-none focus-visible:ring-2 focus-visible:ring-[#3264F8] rounded disabled:opacity-50';
export const INPUT =
  'min-h-[44px] flex-1 min-w-0 rounded-lg border border-white/10 bg-[#0a0a0a] px-3 text-sm text-[#f5f5f5] placeholder-[#a3a3a3] ' +
  'focus:outline-none focus:border-[#3264F8]/60 focus-visible:ring-2 focus-visible:ring-[#3264F8]/40';
